import { GdkTabs } from "@gdk/tabs";
import { useEffect, useRef } from "react";
import { v4 } from "uuid";

function TabsInner({ content, initialTabOpen, id }) {
    const gdkTabsRef = useRef(null);

    useEffect(() => {
        try {
            gdkTabsRef.current = new GdkTabs({
                content: `#${id}`,
                initialTabOpen: initialTabOpen
            });
        } catch (error) {
            console.error("Error initializing GdkTabs:", error);
        }

        return () => {
            try {
                if (gdkTabsRef.current) {
                    gdkTabsRef.current.destroy();
                    gdkTabsRef.current = null;
                }
            } catch (error) {
                console.warn("Error cleaning up GdkTabs:", error);
                gdkTabsRef.current = null;
            }
        };
    }, [id, initialTabOpen]);

    return (
        <div id={id} className="tabs">
            <div className="tabs-container">
                {Object.keys(content).map((title) =>
                    <a key={`tab-key-${title}`} className="tab" href="#" role="tab" aria-controls={`panel-${title}`}>
                        <span>{title}</span>
                    </a>
                )}
            </div>

            {Object.keys(content).map((title) =>
                <div id={`panel-${title}`} key={`panel-key-${title}`} className="panel" role="tabpanel" aria-labelledby={`tab-${title}`}>
                    <div className="panel-content">{content[title]}</div>
                </div>
            )}
        </div>
    );
}

export default function Tabs({
    content = {},
    initialTabOpen = 1
}) {

    const contentKey = Object.keys(content).join('-');
    const idRef = useRef(`tabs-${v4()}`);

    return (
        <TabsInner
            key={`tabs-${contentKey}-${initialTabOpen}`}
            id={idRef.current}
            content={content}
            initialTabOpen={initialTabOpen}
        />
    );
}
